import { Card, IconButton } from "@mui/material";
import HeaderGestorConfigs from "../../../../../utils/headerGestorConfigs";
// import VisibilityIcon from "@mui/icons-material/DescriptionOutlined";
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import Date from "../../../../../utils/date";
import { DesalfandegamentoPDF } from "./desalfandegamento/desalfandegamentoPDF";
import { CertificadoNCotroladoPdf } from "./certificado/autorizacaoImportacaoNcontrolado";
import { CertificadoInternacionamento } from "./certificado/certificadoInternacionamento";
import { CertificadoMedicamento } from "./certificado/certificadoMedicamento";
import { CertificadoEquipamentos } from "./certificado/certificadoEquipamentos";
import { DesalfandegamentoDeclaracao } from "./desalfandegamentoNovos/desalfandegamentoDeclaracao";


export default function DocumentosEmitidos({ solicitacaoImportacao }) {

    const handleCertificado = (solicitacaoImportacao, certificado) => {
        const categoriasInternacionamento = ['Estupefaciente', 'Percursores', 'Psicotrópico'];

        if (certificado?.tipoCertificado === 'Medicamento' && categoriasInternacionamento.includes(certificado?.productoRefente?.categoria)) {
            CertificadoInternacionamento(solicitacaoImportacao, certificado);
        }
        else if (certificado?.tipoCertificado === 'Equipamento') {
            CertificadoEquipamentos(solicitacaoImportacao, certificado);
        } else if (certificado?.tipoCertificado === 'Medicamento') {
            CertificadoMedicamento(solicitacaoImportacao, certificado);
        }
    };

    return (
        solicitacaoImportacao?.certificado &&
        <Card style={{ padding: 15, borderRadius: 5 }}>

            <HeaderGestorConfigs title={'CERTIFICADOS EMITIDOS'} />

            {solicitacaoImportacao?.solicitacaoArea === 'Não Controlados' ?
                // {solicitacaoImportacao?.certificado[0]?.productoRefente?.tipo === 'Não Controlados' ?
                <p>
                    <IconButton color="secondary"
                        onClick={() => { CertificadoNCotroladoPdf(solicitacaoImportacao, solicitacaoImportacao?.certificado) }}
                    >
                        <DownloadOutlinedIcon />
                    </IconButton>

                    AUTORIZAÇÃO DE IMPORTAÇÃO_NÃO CONTROLADOS_ <Date date={solicitacaoImportacao?.certificado[0]?.dataEmissao} />
                </p>
                : solicitacaoImportacao?.certificado.map((certificado) =>
                    <p>
                        <IconButton color="secondary"
                            // onClick={() => { CertificadoPdf(solicitacaoImportacao, certificado) }}
                            onClick={() => handleCertificado(solicitacaoImportacao, certificado)}
                        >
                            <DownloadOutlinedIcon />
                        </IconButton>

                        CERTIFICADO DE CONTROLADO_{certificado?.productoRefente?.nome}_{certificado?.numeroCertificado} _ <Date date={certificado.dataEmissao} />
                    </p>)
            }

            {solicitacaoImportacao?.declaracao?.dataAprovacao &&
                <>
                    <HeaderGestorConfigs title={'DECLARAÇÃO EMITIDA PARA DESALFANDEGAMENTO'} />
                    <p>
                        <IconButton color="secondary"
                            // onClick={() => { DesalfandegamentoPDF(solicitacaoImportacao) }}
                            onClick={() => { DesalfandegamentoDeclaracao(solicitacaoImportacao) }}
                        >
                            <DownloadOutlinedIcon />
                        </IconButton>

                        DECLARAÇÃO DE DESALFANDEGAMENTO_{solicitacaoImportacao?.declaracao?.numeroDeclaracao} _ <Date date={solicitacaoImportacao?.declaracao.dataEmissao} />
                    </p>
                </>
            }
            {/* <Date date={solicitacaoImportacao?.declaracao.dataDespacho} */}

        </Card>
    )
}
